









import {mixins} from "vue-class-component";
import {CommonMixin} from "../../services/mixin";
import {Component, Emit, Model, Prop} from "vue-property-decorator";
import locale from 'ant-design-vue/lib/date-picker/locale/vi_VN';
import moment, {Moment} from "moment";
import 'moment/locale/vi';

@Component({
    name: "MillisecondMonthPicker"
})
export default class extends mixins(CommonMixin) {
    @Prop({type: String, default: "Chọn tháng"})
    readonly placeholder!: string;

    @Model("change", {type: Number})
    readonly monthMls!: number;

    @Emit("change")
    handleChange(value?: Moment) {
        if (!value) return undefined;
        return moment(value).startOf('month').valueOf();
    }

    get monthFormat() {
        return "MM/YYYY";
    }

    get locale() {
        return locale;
    }

    get defaultValue() {
        return moment().locale("vi");
    }

    get monthMoment() {
        return this.monthMls ? moment(this.monthMls) : undefined;
    }
}
